import { useState, useEffect } from 'react'
import Modal from '../../components/Modal'
import Boton from '../../components/Boton'
import MoneyInput from '../../components/MoneyInput'
import { erpApi } from '../../api/erp'
import { nuevoUuid, mensajeError, st } from './_helpers'
import { Campo, CajaError } from './_comun'
import { space } from '../../design/tokens'

/**
 * Alta de un tercero PROPIO de la 900 en el maestro del ERP. El código lo
 * pone el ERP (9-000001): no se pide ni se propone. Los selects salen de
 * GET terceros/catalogos — el id ES el código de ARCA, no se hardcodea.
 * RI / Monotributo / Exento exigen CUIT: lo valida el ERP y acá se muestra.
 */
const VACIO = {
  razon_social: '', nombre_fantasia: '', tipo_documento_id: '', nro_documento: '', condicion_iva_id: '',
  email: '', telefono: '', observaciones: '', es_cliente: true, es_proveedor: false,
  condicion_pago_id: '', limite_credito: '',
  domicilio: { calle: '', numero: '', piso_depto: '', localidad: '', provincia_id: '', codigo_postal: '' },
}

export default function ModalAltaTercero({ rol = 'cliente', onClose, onCreado }) {
  const [uuid] = useState(nuevoUuid)
  const [cat, setCat] = useState(null)
  const [form, setForm] = useState({ ...VACIO, es_cliente: rol !== 'proveedor', es_proveedor: rol === 'proveedor' })
  const [error, setError] = useState('')
  const [enviando, setEnviando] = useState(false)

  useEffect(() => {
    erpApi.catalogosTerceros().then(({ data }) => setCat(data)).catch(e => setError(mensajeError(e)))
  }, [])

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e?.target ? (e.target.type === 'checkbox' ? e.target.checked : e.target.value) : e }))
  const setDom = (k) => (e) => setForm(f => ({ ...f, domicilio: { ...f.domicilio, [k]: e.target.value } }))

  const guardar = async (e) => {
    e.preventDefault()
    setError('')
    if (!form.es_cliente && !form.es_proveedor) { setError('Tiene que ser cliente, proveedor o los dos.'); return }
    const dom = form.domicilio.calle.trim() ? form.domicilio : null
    if (dom && (!dom.localidad.trim() || dom.provincia_id === '')) {
      setError('Si cargás domicilio, localidad y provincia son obligatorias.'); return
    }
    setEnviando(true)
    try {
      const payload = { uuid, ...form, domicilio: dom || undefined }
      const { data } = await erpApi.crearTercero(payload)
      onCreado(data.tercero)
    } catch (err) {
      setError(mensajeError(err))
    } finally { setEnviando(false) }
  }

  return (
    <Modal title={`Nuevo ${rol === 'proveedor' ? 'proveedor' : 'cliente'} de la 900`} onClose={onClose} maxWidth="680px">
      <form onSubmit={guardar} style={st.seccion}>
        <p style={{ ...st.info, margin: 0 }}>
          Nace privado de la 900 (emp_0 no lo ve). El código lo asigna el ERP al guardar.
        </p>
        <Campo label="Razón social"><input style={st.input} value={form.razon_social} onChange={set('razon_social')} required autoFocus /></Campo>
        <div style={st.grid3}>
          <Campo label="Tipo de documento">
            <select style={st.input} value={form.tipo_documento_id} onChange={set('tipo_documento_id')} required>
              <option value="">…</option>
              {(cat?.tipos_documento || []).map(t => <option key={t.id} value={t.id}>{t.nombre}</option>)}
            </select>
          </Campo>
          <Campo label="Nº documento"><input style={st.input} value={form.nro_documento} onChange={set('nro_documento')} inputMode="numeric" required /></Campo>
          <Campo label="Condición IVA">
            <select style={st.input} value={form.condicion_iva_id} onChange={set('condicion_iva_id')} required>
              <option value="">…</option>
              {(cat?.condiciones_iva || []).map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
            </select>
          </Campo>
        </div>
        <div style={st.grid2}>
          <Campo label="Nombre de fantasía"><input style={st.input} value={form.nombre_fantasia} onChange={set('nombre_fantasia')} /></Campo>
          <Campo label="Email"><input style={st.input} type="email" value={form.email} onChange={set('email')} /></Campo>
          <Campo label="Teléfono"><input style={st.input} value={form.telefono} onChange={set('telefono')} /></Campo>
          <div style={{ display: 'flex', gap: space.lg, alignItems: 'flex-end', paddingBottom: space.sm }}>
            <label style={st.check}><input type="checkbox" checked={form.es_cliente} onChange={set('es_cliente')} /> Cliente</label>
            <label style={st.check}><input type="checkbox" checked={form.es_proveedor} onChange={set('es_proveedor')} /> Proveedor</label>
          </div>
        </div>

        <div style={st.grid2}>
          <Campo label="Condición de pago (cartera 900)">
            <select style={st.input} value={form.condicion_pago_id} onChange={set('condicion_pago_id')}>
              <option value="">Sin definir</option>
              {(cat?.condiciones_pago || []).map(c => <option key={c.id} value={c.id}>{c.nombre}{c.dias != null ? ` (${c.dias} días)` : ''}</option>)}
            </select>
          </Campo>
          <Campo label="Límite de crédito (cartera 900)"><MoneyInput style={st.input} value={form.limite_credito} onChange={set('limite_credito')} placeholder="" /></Campo>
        </div>

        <div style={st.label}>Domicilio (opcional — se guarda completo, sin recortes)</div>
        <div style={st.grid3}>
          <Campo label="Calle" style={{ gridColumn: 'span 2' }}><input style={st.input} value={form.domicilio.calle} onChange={setDom('calle')} /></Campo>
          <Campo label="Número"><input style={st.input} value={form.domicilio.numero} onChange={setDom('numero')} /></Campo>
          <Campo label="Piso / Depto"><input style={st.input} value={form.domicilio.piso_depto} onChange={setDom('piso_depto')} /></Campo>
          <Campo label="Localidad"><input style={st.input} value={form.domicilio.localidad} onChange={setDom('localidad')} /></Campo>
          <Campo label="Provincia">
            <select style={st.input} value={form.domicilio.provincia_id} onChange={setDom('provincia_id')}>
              <option value="">…</option>
              {(cat?.provincias || []).map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
            </select>
          </Campo>
          <Campo label="Código postal"><input style={st.input} value={form.domicilio.codigo_postal} onChange={setDom('codigo_postal')} /></Campo>
        </div>

        <Campo label="Observaciones"><textarea style={st.textarea} value={form.observaciones} onChange={set('observaciones')} /></Campo>

        <CajaError>{error}</CajaError>
        <div style={st.pie}>
          <Boton variante="ghost" onClick={onClose} type="button">Cancelar</Boton>
          <Boton variante="primary" type="submit" disabled={enviando || !cat}>{enviando ? 'Guardando…' : 'Guardar en el ERP'}</Boton>
        </div>
      </form>
    </Modal>
  )
}
